<div class="modal-wrapper">
  <img src="../../../assets/icon/agree.png" alt="agree icon" />
  <p>
    {{ message }}
  </p>
  <div class="modal-wrapper__buttons">
    <app-button
      (onClick)="click()"
      [innerText]="'MODALS.WORK_FINISHED.CONFIRM' | translate"
    ></app-button>
  </div>
</div>
